<div class="container">
  <div class="page-header text-center" style="padding-top: 20px">
    <p class="text-align-left" style="text-align: left; color: #4b3e90">
      <span>Home</span> &gt; <span>Choir Sessions</span> &gt;
      {{ ChoirList?.title }}
    </p>
  </div>
  <div class="backDiv mt-2 mb-2">
    <p routerLink="/main//home" style="cursor: pointer">
      <img src="../../../../assets/images/IconleftTurn.svg" /> Back
    </p>
  </div>
  <div class="row">
    <div class="col-md-6 course-image">
      <h1 class="course-title">{{ ChoirList?.title }}</h1>
      <img [src]="ChoirList?.profilePic ? ChoirList?.profilePic : '../../../../assets/images/dummyImage5.svg'"
        alt="Choir Image" class="img-fluid rounded w-100" />

    </div>
    <div class="col-md-6 pt-5">
      <div class="course-details">
        <h2 class="text-black" *ngIf="ChoirList?.amount != ''">
          ${{ ChoirList?.totalAmount }}/-
          <span style="color: rgb(127, 127, 127); font-weight: 300; font-size: 16px">(<span *ngIf="ChoirList?.taxType == 'fixed'">$</span>{{ ChoirList?.tax }} <span *ngIf="ChoirList?.taxType == 'percentage'">%</span>
            Tax included)</span>
        </h2>
        <h2 class="" style="color: rgb(148 153 161)" *ngIf="ChoirList?.amount == '' && ChoirList?.tax == ''">
          To Be Decided
        </h2>

        <div class="course-info">
          <p style="color: #667085; font-size: 14px">Date:</p>
          <span *ngIf="ChoirList?.startDateInSeconds != ''">
            <p>
              {{ convertSecondsToDate(ChoirList?.startDateInSeconds) }}
              <span *ngIf="ChoirList?.endDateInSeconds == ''">( To Be Decided )</span>
              <span *ngIf="ChoirList?.endDateInSeconds != ''">
                - {{ convertSecondsToDate(ChoirList?.endDateInSeconds) }}</span>
            </p>
          </span>
          <!-- 
          <span *ngIf="ChoirList?.startDateInSeconds == '' && ChoirList?.endDateInSeconds != ''">
            <p class="toBeDecided">(To Be Decided )</p>
          </span>
          <span *ngIf="ChoirList?.startDateInSeconds != '' && ChoirList?.endDateInSeconds == ''">
            <p class="toBeDecided">{{ convertSecondsToDate(ChoirList?.startDateInSeconds) }} (To Be Decided)</p>
          </span>
          <span *ngIf="ChoirList?.startDateInSeconds == '' && ChoirList?.endDateInSeconds == ''">
            <p class="toBeDecided">(To Be Decided)</p>
          </span> -->
        </div>

        <div class="course-info">
          <p style="color: #667085; font-size: 14px">Time:</p>
          <p>
            <span *ngIf="ChoirList?.startTimeInSeconds != ''">{{ convertSecondsToTime(ChoirList?.startTimeInSeconds) }}
            </span>
            <span *ngIf="ChoirList?.endTimeInSeconds != ''">- {{ convertSecondsToTime(ChoirList?.endTimeInSeconds)
              }}</span>
          </p>
          <p *ngIf="ChoirList?.startTimeInSeconds == '' && ChoirList?.endTimeInSeconds == ''" class="toBeDecided">
            To Be Decided
          </p>
          <div class="course-info">
            <p style="color: #667085; font-size: 14px">Address:</p>
            <p *ngIf="ChoirList?.Address != ''">
              {{ ChoirList?.Address }}
            </p>
            <p *ngIf="ChoirList?.Address == ''" class="toBeDecided">To Be Decided</p>
          </div>
          <div class="course-info">
            <p style="color: #667085; font-size: 14px">About:</p>
            <p *ngIf="ChoirList?.description != ''">
              {{ ChoirList?.description }}
            </p>
            <p *ngIf="ChoirList?.description == ''" class="toBeDecided">To Be Decided</p>
          </div>
          <div class="topSpace mt-3" *ngIf="ChoirList?.amount == ''" style="padding-top: 4em"></div>

          <div class="applyNow d-flex">
            <button class="btn btn-Login" #Btn (click)="OpenModal(addedactivities, Btn, 'data')"
              *ngIf="ChoirList?.amount != ''">
              Apply Now
            </button>
            <!-- <div
              class="saveUnsave"
              style="
                justify-content: center;
                display: flex;
                align-items: center;
              "
            >
              <span
                class="savedIcon mx-3"
                (click)="savechoir(ChoirList, 'save')"
                *ngIf="ChoirList?.isSaved == false"
              >
                <img
                  src="../../../../assets/images/unsave.svg"
                  style="cursor: pointer"
                />
              </span>
              <span
                class="savedIcon mx-3"
                (click)="savechoir(ChoirList, 'unsave')"
                *ngIf="ChoirList?.isSaved == true"
              >
                <img
                  src="../../../../assets/images/Saved.svg"
                  style="cursor: pointer"
                />
              </span>
            </div> -->
          </div>

          <!-- <span class="savedIcon mx-3">
            <img
              id="toggleIcon"
              src="../../../../assets/images/unsave.svg"
              style="cursor: pointer"
              (click)="toggleSave()"
            />
          </span> -->

          <!-- #Btn
          (click)="OpenModal(addedactivities, Btn, 'data')" -->
        </div>
      </div>
    </div>

    <div class="course-description" *ngIf="ChoirList?.description != ''">
      <p style="color: #667085; font-size: 16px">About Choirs</p>
      <p>
        {{ ChoirList?.description }}
      </p>
    </div>

    <div class="teachers" *ngIf="ChoirList?.teacherDescription != ''">
      <p style="color: #667085; font-size: 16px">Teachers</p>
      <p class="pt-1">
        {{ ChoirList?.teacherDescription }}
      </p>
      <div class="row">
        <div class="col-md-4 text-center" *ngFor="let item of teachersArray">
          <div class="teacher-card">
            <img src="{{ item?.profilePic ? item?.profilePic : '../../../../assets/images/person1.svg' }}" alt="Cameron"
              class="img-fluid" style="height: 150px; width: 150px" />
            <p>{{ item?.firstName }} {{ item?.lastName }}</p>
          </div>
        </div>
        <!-- <div class="col-md-4 text-center">
          <div class="teacher-card">
            <img
              src="../../../../assets/images/person2.svg"
              alt="Jenny Wilson"
              class="img-fluid"
            />
            <p>Jenny Wilson</p>
          </div>
        </div>
        <div class="col-md-4 text-center">
          <div class="teacher-card">
            <img
              src="../../../../assets/images/person3.svg"
              alt="Jane Cooper"
              class="img-fluid"
            />
            <p>Jane Cooper</p>
          </div>
        </div> -->
      </div>
    </div>
    <div class="teachers" *ngIf="ChoirList?.teacherDescription == ''">
      <p style="color: #667085; font-size: 16px">Teachers</p>
      <p class="pt-1" class="toBeDecided">To Be Decided</p>
    </div>
  </div>
</div>

<ng-template #addedactivities let-modal>
  <app-spinner *ngIf="isLoading1" [type]="'normal'"></app-spinner>
  <div class="modal-header">
    <h5 class="modal-title">Select Child</h5>
    <!-- <button
      type="button"
      class="close btn cross_btn"
      data-dismiss="modal"
      (click)="closeModal('dismiss')"
    >
      <span aria-hidden="true">&times;</span>
    </button> -->
    <div class="crossIcon">
      <img src="../../../../assets/images/purple-cross.svg" style="cursor: pointer" data-dismiss="modal"
        (click)="closeModal('dismiss')" />
    </div>
  </div>
  <div class="add_Child_BTN pb-3 my-3 mx-3" style="height: 50px; display: flex; justify-content: center"
    *ngIf="addtChild == false">
    <div class="btnDiv">
      <button class="btn btn-Login2" (click)="addChild()">+ Add Child</button>
    </div>
  </div>

  <div class="modal-body" *ngIf="addtChild == true">
    <div class="addChildForm p-4">
      <div class="form-group">
        <label class="profile_Pic_Label cursor">
          <img [src]="profileImag ? profileImag : '../../../assets/images/dummy_Pic.svg'"
            style="height: 150px; width: 150px; border-radius: 10px" />
          <p class="profile_Pic_Text">+ Add Profile Photo</p>
          <input #Btn type="file" accept="image/*" class="profile_Pic_Input"
            (change)="fileChangeEvent2($event, addKidmodal, Btn, i)" hidden />
        </label>
      </div>
      <div class="form-group mt-2">
        <label for="firstName">First Name</label>
        <input type="text" class="form-control form_Input mt-2" id="firstName" placeholder="Enter First Name"
          [(ngModel)]="firstName" [ngModelOptions]="{ standalone: true }" required />
        <!-- <div
            *ngIf="
              !selectedChild.firstName &&
              (firstName?.dirty || firstName?.touched)
            "
            class="errorinput text-left"
          >
            *First Name is required.
          </div> -->
      </div>

      <div class="form-group mt-2">
        <label for="lastName">Last Name</label>
        <input type="text" class="form-control form_Input mt-2" id="lastName" placeholder="Enter Last Name"
          [(ngModel)]="lastName" [ngModelOptions]="{ standalone: true }" required />
        <!-- <div
            *ngIf="
              !selectedChild.lastName &&
              (lastName?.dirty || lastName?.touched)
            "
            class="errorinput text-left"
          >
            *Last Name is required.
          </div> -->
      </div>

      <div class="d-flex">
        <div class="form-group mt-2 px-1 col-md-6" style="padding-left: 0px">
          <label for="age">Age</label>
          <input type="number" class="form-control form_Input mt-2" id="age" placeholder="Enter Age" [(ngModel)]="age"
            [ngModelOptions]="{ standalone: true }" required />
          <!-- <div
            *ngIf="!selectedChild.age && (age?.dirty || age?.touched)"
            class="errorinput text-left"
          >
            *Age is required.
          </div> -->
        </div>

        <div class="form-group mt-2 col-md-6">
          <label for="gender">Gender</label>
          <select class="form-control form_Input mt-2" id="gender" [(ngModel)]="gender"
            [ngModelOptions]="{ standalone: true }" required>
            <option value="" disabled>Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
          <!-- <div
            *ngIf="!selectedChild.gender && (gender?.dirty || gender?.touched)"
            class="errorinput text-left"
          >
            *Gender is required.
          </div> -->
        </div>
      </div>
    </div>
    <div class="btnDiv" *ngIf="addtChild == true" style="display: flex; justify-content: center">
      <button class="btn btn-Login2" (click)="saveChild()">Save</button>
    </div>
  </div>
  <div class="modal-footer" style="justify-content: center; display: block">
    <div class="multiSelectDropDown pt-4 pb-5" *ngIf="kidList">
      <ng-multiselect-dropdown name="child" [placeholder]="'Select Child'" [settings]="dropdownSettings"
        [data]="kidList" [(ngModel)]="selectedItems" (onSelect)="onItemSelect($event)" (onDeSelect)="onDeSelect($event)"
        class="customDropdown"></ng-multiselect-dropdown>
    </div>
    <!-- [disabled]="disabled" -->
    <div class="proceedBtn mt-3" style="justify-content: center; display: flex">
      <button [disabled]="selectedItems?.length == 0" class="btn btn-Login" #Btn
        (click)="saveBookingChild(userCheckoutScreen, Btn, 'data')">
        Proceed <img src="../../../../assets/images/IconRightturn.svg" />
      </button>
      <!-- #Btn
      (click)="OpenModal(userCheckoutScreen, Btn, 'data')" -->
    </div>
  </div>
  <!-- [(ngModel)]="selectedItems" -->
</ng-template>
<ng-template #userCheckoutScreen let-modal>
  <app-spinner *ngIf="isLoading1" [type]="'normal'"></app-spinner>

  <!-- Modal Header -->
  <div class="modal-header">
    <h5 class="modal-title">Summary</h5>
    <div class="crossIcon">
      <img src="../../../../assets/images/purple-cross.svg" style="cursor: pointer" data-dismiss="modal"
        (click)="closeModal('dismiss')" />
    </div>
  </div>

  <!-- Modal Body -->
  <div class="modal-body">
    <div class="summary-section">
      <table class="summary-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Age</th>
            <th>Gender</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of kidsDetail">
            <td>
              {{ item?.firstName ? item?.firstName : "--" }}
              {{ item?.lastName ? item?.lastName : "--" }}
            </td>
            <td>{{ item?.age ? item?.age : "--" }}</td>
            <td>{{ item?.gender ? item?.gender : "--" }}</td>
          </tr>
          <!-- <tr>
            <td>Kelly Jay</td>
            <td>15</td>
            <td>Male</td>
          </tr> -->
        </tbody>
      </table>

      <div class="couponDiv mb-4 d-flex">
        <div class="col-md-8">
          <input type="text" class="form-control form_Input mt-2" id="gender" [(ngModel)]="CouponCode"
            [ngModelOptions]="{ standalone: true }" required placeholder="Enter Coupon Code" list="couponListOptions"
            [disabled]="isAppliedCode == true" />
        </div>
        <div class="col-md-2 mt-2 mx-2">
          <button *ngIf="isAppliedCode == false" class="btn btn-Login2" style="width: 140px" (click)="applyCode()"
            [disabled]="CouponCode == ''">
            Apply Code
          </button>
          <button *ngIf="isAppliedCode == true" class="btn btn-Login2" style="width: 140px" (click)="removeCode()">
            Remove Code
          </button>
        </div>
      </div>

      <p class="paymentTxt">Payment Summary</p>
      <div class="payment-summary">
        <div class="summary-item">
          <span>Total</span>
          <span>${{ bookingDetail?.amount?.toFixed(2) }}</span>
        </div>
        <div class="summary-item">
          <span>Taxes</span>
          <span>${{ bookingDetail?.totalTaxes?.toFixed(2) }} </span>
        </div>
        <div class="summary-item" *ngIf="bookingDetail2?.discountAmount != 0 && bookingDetail2?.discountAmount"
          style="color: red">
          <span>Discount</span>
          <span>-${{ bookingDetail2?.discountAmount?.toFixed(2) }} </span>
        </div>
        <div class="summary-item grand-total">
          <span>Grand Total</span>
          <span>${{ bookingDetail2?.totalAmount }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Footer -->
  <div class="modal-footer" style="justify-content: center">
    <button class="btn btn-Login" (click)="saveBooking()">
      Checkout <img src="../../../../assets/images/IconRightturn.svg" />
    </button>
  </div>
</ng-template>
<ng-template #addKidmodal let-modal>
  <app-spinner *ngIf="isLoading1" [type]="'normal'"></app-spinner>
  <div class="modal-header">
    <h5 class="modal-title">Kid Image</h5>
    <button type="button" class="close btn cross_btn" data-dismiss="modal" (click)="closeModal('dismiss')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-md-12 mt-2 pe-5 ps-5">
      <div class="cropper" *ngIf="imageChangedEvent2">
        <h5 class="cropper-title">Crop Image</h5>
        <image-cropper [imageChangedEvent]="imageChangedEvent2" [maintainAspectRatio]="true" [aspectRatio]="1 / 1"
          cropperMinWidth="200" cropperMinHeight="200" resizeToWidth="600" resizeToHeight="600" format="png"
          (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
          (loadImageFailed)="loadImageFailed()">
        </image-cropper>
        <!-- <button class="btn btn-danger mr-rt-1x" (click)="cancel()">
          Cancel
        </button> -->
        <div class="savebtn mt-4 d-flex justify-content-center">
          <button (click)="save2()" class="btn btn-Login ml-2">Save</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>